$(document).ready( function () {
    const horizontalContainers = $('.horizontal-container');
    // Dont run unless this container exists
    if (horizontalContainers.length >= 1) {
        // Loop, in the event there is more than 1 container on the page
        horizontalContainers.each(function (i, container) {
            getHorizontalAds().then(function (res) {
                let adHtml = '';
                res.forEach(function (ad) {
                    adHtml += makeHorizontalAd(ad);
                });
                $(container).html(adHtml);
            });
        });
    }

    function makeHorizontalAd(ad) {
        return `
        <div class="small_horizontal">
            <a href="${ad.links.href}" target="_blank">
                <img src="${ad.links.img}" width="120" height="240" border="0" class="m-b-20" />
            </a>
        </div>`;
    }

    function getHorizontalAds() {
        return $.get('/horizontal/ads');
    }

});
